import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import {
  CONTACT_EMAIL_SEARCH_COLUMNS,

} from "./consts";
import { ContactEmailSearchResultsProps } from "./types";
import { useTranslate } from "helpers";

const ContactSearchResults: React.FC<ContactEmailSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onDeleteClick,
    onEmailClick

  } = props;

  const { t } = useTranslate();

  return (
    <>
      <TableSearch
        columns={CONTACT_EMAIL_SEARCH_COLUMNS(t, onDeleteClick, onEmailClick)}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        disablePagination={true}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};
export default memo(ContactSearchResults);
